export const transactionIsCreatingSubTransactions = (transaction) =>
  transaction?.attributes?.metadata?.isCreatingSubTxs ?? false;

export const transactionIsUpdatingSubTransactions = (transaction) =>
  transaction?.attributes?.metadata?.isUpdatingSubTxs ?? false;

export const getTransactionRecurringData = (transaction) =>
  transaction?.attributes?.protectedData?.recurringBooking;

export const getSubTransactions = (transaction) =>
  transaction?.attributes?.metadata?.subTransactions ?? [];

export const getFailedSubTransactions = (transaction) =>
  transaction?.attributes?.metadata?.failedSubTransactions ?? [];

export const getFailedIntervals = (transaction) =>
  transaction?.attributes?.metadata?.failedIntervals ?? [];

export const getFailedSubTransactionsNoOps = (transaction) =>
  transaction?.attributes?.metadata?.failedSubTransactionsNoOps ?? [];

export const getFailedIntervalsNoOps = (transaction) =>
  transaction?.attributes?.metadata?.failedIntervalsNoOps ?? [];
